module.exports = __webpack_public_path__ + "static/media/my-info-menu-main-active-icon.40748b1b.svg";